import { useEffect } from "react";
import { auth } from "../services/firebase";
import { signOut } from "firebase/auth";

export default function useAutoLogout(timeoutMinutes = 30) {
  useEffect(() => {
    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    // Default behavior:
    // - localhost: 5 minutes (unless caller explicitly sets a different value)
    // - prod: timeoutMinutes (default 30)
    const effectiveTimeoutMinutes =
      isLocalhost && (timeoutMinutes == null || timeoutMinutes === 30)
        ? 5
        : timeoutMinutes;

    const timeout = Number(effectiveTimeoutMinutes) * 60 * 1000;

    // Guard against invalid values
    if (!Number.isFinite(timeout) || timeout <= 0) {
      console.warn(
        "useAutoLogout: invalid timeoutMinutes:",
        effectiveTimeoutMinutes,
      );
      return;
    }

    let logoutTimer;

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        signOut(auth).then(() => {
          console.log("Uživatel byl automaticky odhlášen kvůli nečinnosti.");
        });
      }, timeout);
    };

    const handleActivity = () => resetTimer();

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, handleActivity));

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        clearTimeout(logoutTimer);
      } else {
        resetTimer();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    resetTimer(); // start timer

    return () => {
      clearTimeout(logoutTimer);
      events.forEach((event) =>
        window.removeEventListener(event, handleActivity),
      );
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [timeoutMinutes]);
}
